<template>
<b-button variant="primary" @click="startCall()">
  <img src="https://img.icons8.com/ios-glyphs/16/ffffff/phone-disconnected.png" />
  Call
</b-button>
</template>
<script>
import $twilio from '@/services/twilio';
export default {
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  methods: {
    startCall() {
      $twilio.call(this.member);
    }
  },
}
</script>
